export default "https://cdn-static.gokick.com/assets/faf4ec4796b5499b7477edf17656e3681d9dd642/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";